import React from 'react';
import { SearchIcon } from 'lucide-react';
interface BidFiltersProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  categoryFilter: string;
  setCategoryFilter: (category: string) => void;
}
export function BidFilters({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  categoryFilter,
  setCategoryFilter
}: BidFiltersProps) {
  const categories = ['All Categories', 'Health & Medical', 'Infrastructure', 'Education & Training', 'Consulting Services', 'Agriculture', 'Energy', 'Technology', 'Economic Development'];
  return <div className="bg-white rounded-lg border border-gray-border p-6 mb-8" data-id="element-48">
      <div className="grid md:grid-cols-3 gap-4" data-id="element-49">
        <div data-id="element-50">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-51">
            Search
          </label>
          <div className="relative" data-id="element-52">
            <SearchIcon size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-53" />
            <input type="text" placeholder="Search bids..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-54" />
          </div>
        </div>

        <div data-id="element-55">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-56">
            Status
          </label>
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-57">
            <option value="all" data-id="element-58">All Status</option>
            <option value="open" data-id="element-59">Open</option>
            <option value="closing-soon" data-id="element-60">Closing Soon</option>
            <option value="closed" data-id="element-61">Closed</option>
          </select>
        </div>

        <div data-id="element-62">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-63">
            Category
          </label>
          <select value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-64">
            {categories.map(cat => <option key={cat} value={cat} data-id="element-65">
                {cat}
              </option>)}
          </select>
        </div>
      </div>
    </div>;
}